import {
  ActionBody,
  Body,
  Columnz,
  DataTablez,
  RenderHeader,
  StatusBody,
  TimeBody,
  useGetParams,
} from "@/components/DataTable";
import { Dropdownz, GridForm } from "@/components/ListForm";
import { Button } from "@/uiCore";
import { useState } from "react";
import { useCountListSheet, useListSheet } from "../util";
import { updateSheet, updateSheetDetail } from "../api";
import { useDispatch } from "react-redux";
import { showToast } from "@/redux/features/toast";
import { listToast } from "@/utils";
import { confirmDialog } from "primereact/confirmdialog";
const Header = (props) => {
  const {
    setParamsPaginator,
    paramsPaginator,
    categories,
    exchanges,
    users,
    news,
  } = props;
  const [filter, setFilter] = useState({});

  return (
    <GridForm
      paramsPaginator={paramsPaginator}
      setParamsPaginator={setParamsPaginator}
      filter={filter}
      setFilter={setFilter}
      className="lg:col-9"
    >
      <Dropdownz
        value={filter.news_id}
        options={news}
        placeholder="Chọn sự kiện"
        optionLabel="title"
        onChange={(e) => setFilter({ ...filter, news_id: e.target.value })}
      />
      {/* <Dropdownz
        value={filter.type_news}
        options={news_types}
        placeholder="Chọn loại sự kiện"
        onChange={(e) => setFilter({ ...filter, type_news: e.target.value })}
      /> */}
      <Dropdownz
        value={filter.category_id}
        options={categories}
        placeholder="Chọn dự án"
        onChange={(e) => setFilter({ ...filter, category_id: e.target.value })}
      />
      <Dropdownz
        value={filter.exchange_id}
        options={exchanges}
        placeholder="Chọn đơn vị"
        onChange={(e) => setFilter({ ...filter, exchange_id: e.target.value })}
      />
      <Dropdownz
        value={filter.user_id}
        options={users}
        placeholder="Chọn nhân viên"
        onChange={(e) => setFilter({ ...filter, user_id: e.target.value })}
      />
    </GridForm>
  );
};
const ListSheet = () => {
  const initParams = useGetParams();
  const [paramsPaginator, setParamsPaginator] = useState(initParams);
  const [visible, setVisible] = useState(false);
  const list = useListSheet({ ...paramsPaginator });
  const total = useCountListSheet({ ...paramsPaginator });
  const dispatch = useDispatch();
  const header = RenderHeader({
    title: "Danh sách link sheet",
    add: "/list_sheet/add",
    imports: { route: "/list_sheet/import", action: () => {} },
    // exports: {
    //   route: "/list_sheet/export",
    //   action: () => exportRegisterNews(paramsPaginator),
    //   totalRecords: totalRecords,
    //   file: "list_sheet.xlsx",
    // },
  });
  const accept = async (id) => {
    await updateSheetDetail({ id: id });
    setParamsPaginator((pre) => ({ ...pre, render: !pre.render }));
    dispatch(
      showToast({
        ...listToast[0],
        detail: `Cập nhật dữ liệu thành công!`,
      })
    );
  };
  const confirm1 = (id) => {
    confirmDialog({
      message: "Xác nhận cập nhật thông tin form sheet này",
      header: "Xác nhận",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      accept: () => accept(id),
    });
  };

  return (
    <div className="card">
      <DataTablez
        value={list}
        header={header}
        title="danh sách link sheet"
        totalRecords={total}
        paramsPaginator={paramsPaginator}
        setParamsPaginator={setParamsPaginator}
      >
        <Columnz field="title" header="Tiêu đề " />
        <Columnz
          // body={(e) => (
          //   <span>{String(e?.url)?.substring(0, 40)}...........</span>
          // )}
          body={(e) => (
            <a
              className="cursor-pointer"
              onClick={() => window.open(`${e?.url}`, "_blank")}
            >
              {e?.url}
            </a>
          )}
          header="URL"
        />
        <Columnz
          body={(e) => TimeBody(e?.created_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Ngày tạo"
        />
        <Columnz
          body={(e) => TimeBody(e?.updated_at)}
          bodyStyle={{ textAlign: "center" }}
          header="Cập nhật gần nhất"
        />
        {/* <Columnz
          body={(e) => (
            <div className="flex flex-row">
              <Button
                onClick={() => confirm1(e?.id)}
                type="button"
                icon="pi pi-wrench"
                rounded
                outlined
                className={" mx-auto flex"}
                severity={"info"}
              />
            </div>
          )}
          header="Chỉnh sửa URL"
        /> */}
        <Columnz
          body={(e) => (
            <div className="flex flex-row">
              <Button
                onClick={() => confirm1(e?.id)}
                type="button"
                icon="pi pi-sync"
                rounded
                outlined
                className={" mx-auto flex"}
                severity={"info"}
              />
            </div>
          )}
          header="Cập nhật sheet"
        />
        <Columnz
          header="Trạng thái"
          body={(e) =>
            StatusBody(e, {
              route: "/list_sheet/update",
              action: updateSheet,
            })
          }
          bodyStyle={{ textAlign: "center" }}
        />
        <Columnz
          header="Actions"
          body={(e) =>
            ActionBody(
              e,
              "/list_sheet/detail",
              {
                route: "/list_sheet/delete",
                options: () => {
                  setVisible(true);
                  // setSalePolicy(e.id);
                },
              },
              paramsPaginator,
              setParamsPaginator
            )
          }
          style={{ minWidth: "8rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
      </DataTablez>
    </div>
  );
};
export default ListSheet;
